import { DI } from '@intigral/constant/config/DIContainer';
import { IForgotPasswordGeneratePinByEmailUseCase } from '../../core/usecases/user/ForgotPasswordGeneratePinByEmailUseCase';
import { IForgotPasswordGeneratePinByMsisdnUseCase } from '../../core/usecases/user/ForgotPasswordGeneratePinByMsisdnUseCase';
import { IForgotPasswordUpdatePasswordByEmailUseCase } from '../../core/usecases/user/ForgotPasswordUpdatePasswordByEmailUseCase';
import { IForgotPasswordUpdatePasswordByMsisdnByUseCase } from '../../core/usecases/user/ForgotPasswordUpdatePasswordByMsisdnByUseCase';
import { IForgotPasswordVerifyPinByEmailUseCase } from '../../core/usecases/user/ForgotPasswordVerifyPinByEmailUseCase';
import { IForgotPasswordVerifyPinByMsisdnUseCase } from '../../core/usecases/user/ForgotPasswordVerifyPinByMsisdnUseCase';
import { IGenerateEmailVerifcationPinUseCase } from '../../core/usecases/user/GenerateEmailVerifcationPinUseCase';

import { container } from '../../DataDomain';
import {
    ILocateUserReqBody,
    ILocateUserEntity,
    IGeneratePinReqBody,
    IGeneratePinEntity,
    IVerifyPinReqBody,
    IVerifyPinEntity,
    IResetPasswordStep1ReqBody,
    IResetPasswordStep1Entity,
    IResetPasswordStep2ReqBody,
    IResetPasswordStep2Entity,
    IForgotPasswordGeneratePinEntity,
    IForgotPasswordVerifyPinEntity,
    IForgotPasswordUpdateEmailReqBody,
    IAccountActivationPayload,
    IAccountActivationResponse,
    IPaymentSwitchGenerateParams,
    CSRFTokenRequest,
    IPaymentSwitchVerifyParams,
    IReSubscribeOtpSendParams,
    IReSubscribeOtpSendResponse,
    IReSubscribeOtpVerifyParams,
    IReSubscribeOtpVerifyResponse,
    IReSubscribeCreditCardParams,
    IReSubscribeCreditCardResponse,
    IPaymentConfigEntity,
    IUnsubscribeReqBody,
    IUnsubscribeEntity,
    IUserDetails,
} from '../../entity';
import { IApisLoginResponse } from '../../entity/interface/iAuthApis';
import {
    ILoginStep1Response,
    ILoginSuccessResponse,
    ILoginOtpStep1Response,
    ILoginOtpStep2Response,
    IUserData,
} from '../../entity/interface/iLoginEntities';
import { IQrGenerateCodeResponse, IQrCodePairResponse, IQrCodeLinkRequest } from '../../entity/interface/iQrCodes';
import { ILegacyMigrateRequest, ILegacyMigrateResponse } from '../../entity/interface/iUserApis';
import { IGeneratePinUseCase } from '../../core/usecases/user/GeneratePinUseCase';
import { IGetCountryConfigsUseCase } from '../../core/usecases/user/GetCountryConfigsUseCase';
import { IInternalVerifyUserUseCase } from '../../core/usecases/user/InternalVerifyUserUseCase';
import { ILegacyMigrateGenerateUseCase } from '../../core/usecases/user/LegacyMigrateGenerateUseCase';
import { ILegacyMigrateUseCase } from '../../core/usecases/user/LegacyMigrateUseCase';
import { ILegacyMigrateVerifyUseCase } from '../../core/usecases/user/LegacyMigrateVerifyUseCase';
import { ILocateUserUseCase } from '../../core/usecases/user/LocateUserUseCase';
import { ILoginCredentialsUseCase } from '../../core/usecases/user/LoginCredentialsUseCase';
import { ILoginOtpStep1UseCase } from '../../core/usecases/user/LoginOtpStep1UseCase';
import { ILoginOtpStep2UseCase } from '../../core/usecases/user/LoginOtpStep2UseCase';
import { ILoginStep1UseCase } from '../../core/usecases/user/LoginStep1UseCase';
import { ILoginWithTokenUseCase } from '../../core/usecases/user/LoginWithTokenUseCase';
import { IPaymentSwitchGenerateUseCase } from '../../core/usecases/user/PaymentSwitchGenerateUseCase';
import { IPaymentSwitchVerifyUseCase } from '../../core/usecases/user/PaymentSwitchVerifyUseCase';
import { IQrAuthenticateCodeUseCase } from '../../core/usecases/user/QrAuthenticateCodeUseCase';
import { IQrCodeLinkUseCase } from '../../core/usecases/subscription/QrCodeLinkUseCase';
import { IQrCodeLoginUseCase } from '../../core/usecases/user/QrCodeLoginUseCase';
import { IQrCodePairingUseCase } from '../../core/usecases/user/QrCodePairingUseCase';
import { IQrGenerateCodeUseCase } from '../../core/usecases/user/QrGenerateCodeUseCase';
import { IResetPasswordStep1UseCase } from '../../core/usecases/user/ResetPasswordStep1UseCase';
import { IResetPaswordStep2UseCase } from '../../core/usecases/user/ResetPaswordStep2UseCase';
import { IResubscribeCreditCardUseCase } from '../../core/usecases/user/ResubscribeCreditCardUseCase';
import { IResubscribeOtpSendUseCase } from '../../core/usecases/user/ResubscribeOtpSendUseCase';
import { IResubscribeOtpVerifyUseCase } from '../../core/usecases/user/ResubscribeOtpVerifyUseCase';
import { ISendAccountActivationUseCase } from '../../core/usecases/user/SendAccountActivationUseCase';
import { IUserUnsubscribeUseCase } from '../../core/usecases/user/UserUnsubscribeUseCase';
import { IVerifyEmailVerifcationPinUseCase } from '../../core/usecases/user/VerifyEmailVerifcationPinUseCase';
import { IVerifyPinUseCase } from '../../core/usecases/user/VerifyPinUseCase';
import { IFormSignatureObjectUseCase } from '../../core/usecases/auth/FormSignatureObjectUseCase';

export interface IUserService {
    locateUser(reqBody: ILocateUserReqBody): Promise<ILocateUserEntity>;

    generateEmailVerifcationPin(email: string, language: string): Promise<boolean>;

    verifyEmailVerifcationPin(guid: string): Promise<boolean>;

    loginStep1(username: string, agent: string): Promise<ILoginStep1Response>;

    loginCredentials(
        username: string,
        password: string,
        agent: string,
        tokenNeeded: boolean
    ): Promise<ILoginSuccessResponse>;

    loginWithToken(
        username: string,
        agent: string,
        grantType: string,
        token: string,
        identityToken: string
    ): Promise<IApisLoginResponse>;

    loginOtpStep1(language: string, username: string, agent: string): Promise<ILoginOtpStep1Response>;

    loginOtpStep2(language: string, username: string, agent: string, otp: string): Promise<ILoginOtpStep2Response>;

    generatePin(reqBody: IGeneratePinReqBody): Promise<IGeneratePinEntity>;

    verifyPin(reqBody: IVerifyPinReqBody): Promise<IVerifyPinEntity>;

    resetPasswordStep1(lang: string, reqBody: IResetPasswordStep1ReqBody): Promise<IResetPasswordStep1Entity>;

    resetPaswordStep2(lang: string, reqBody: IResetPasswordStep2ReqBody): Promise<IResetPasswordStep2Entity>;

    forgotPasswordGeneratePinByEmail(email: string): Promise<IForgotPasswordGeneratePinEntity>;

    forgotPasswordGeneratePinByMsisdn(msisdn: string): Promise<IForgotPasswordGeneratePinEntity>;

    forgotPasswordVerifyPinByEmail(otp: string, verificationGuid: string): Promise<IForgotPasswordVerifyPinEntity>;

    forgotPasswordVerifyPinByMsisdn(otp: string, verificationGuid: string): Promise<IForgotPasswordVerifyPinEntity>;

    forgotPasswordUpdatePasswordByEmail(
        reqBody: IForgotPasswordUpdateEmailReqBody
    ): Promise<IForgotPasswordVerifyPinEntity>;

    forgotPasswordUpdatePasswordByMsisdn(
        reqBody: IForgotPasswordUpdateEmailReqBody
    ): Promise<IForgotPasswordVerifyPinEntity>;

    qrGenerateCode(
        type: string,
        username: string | undefined,
        timestamp: number,
        payload: string | { [key: string]: any },
        language: string
    ): Promise<IQrGenerateCodeResponse['data']>;

    qrAuthenticateCode(apiKey: string, qrCode: string, token: string, identityToken: string): Promise<boolean>;

    qrCodeLogin(
        qrCode: string,
        timestamp: number,
        language: string,
        payload: { [key: string]: any } | string
    ): Promise<IUserData>;

    qrCodePairing(bucketId: string): Promise<IQrCodePairResponse>;

    internalVerifyUser(username: string, recaptchaToken: string): Promise<IUserDetails[]>;

    sendAccountActivation(payload: IAccountActivationPayload): Promise<IAccountActivationResponse>;

    paymentSwitchGenerate(payload: IPaymentSwitchGenerateParams, csrfToken?: CSRFTokenRequest): Promise<any>;

    paymentSwitchVerify(payload: IPaymentSwitchVerifyParams, csrfToken?: CSRFTokenRequest): Promise<any>;

    resubscribeOtpSend(
        payload: IReSubscribeOtpSendParams,
        authToken: string,
        authSign: string,
        identityToken: string
    ): Promise<IReSubscribeOtpSendResponse['data']>;

    resubscribeOtpVerify(
        payload: IReSubscribeOtpVerifyParams,
        authToken: string,
        authSign: string,
        identityToken: string
    ): Promise<IReSubscribeOtpVerifyResponse['data']>;

    resubscribeCreditCard(
        payload: IReSubscribeCreditCardParams,
        authToken: string,
        authSign: string,
        csrfToken?: { [key: string]: string }
    ): Promise<IReSubscribeCreditCardResponse>;

    getCountryConfigs(
        username: string,
        identityToken: string,
        apiKey: string,
        authToken: string,
        authSign: string,
        csrfToken?: { [key: string]: string }
    ): Promise<IPaymentConfigEntity>;

    unsubscribe(
        username: string,
        authToken: string,
        authSign: string,
        reqBody?: IUnsubscribeReqBody
    ): Promise<IUnsubscribeEntity>;

    legacyMigrate(
        payload: ILegacyMigrateRequest,
        authToken: string,
        authSign: string,
        csrfToken?: { [key: string]: string }
    ): Promise<ILegacyMigrateResponse>;

    legacyMigrateGenerate(
        payload: ILegacyMigrateRequest,
        authToken: string,
        authSign: string,
        csrfToken?: { [key: string]: string }
    ): Promise<ILegacyMigrateResponse>;

    legacyMigrateVerify(
        payload: ILegacyMigrateRequest,
        authToken: string,
        authSign: string,
        csrfToken?: { [key: string]: string }
    ): Promise<ILegacyMigrateResponse>;
}

export class UserService implements IUserService {
    // Lazy getters for dependencies to avoid circular dependencies
    private get locateUserUseCase(): ILocateUserUseCase {
        return container.resolve<ILocateUserUseCase>(DI.USECASES.ILocateUserUseCase);
    }

    private get generateEmailVerifcationPinUseCase(): IGenerateEmailVerifcationPinUseCase {
        return container.resolve<IGenerateEmailVerifcationPinUseCase>(DI.USECASES.IGenerateEmailVerifcationPinUseCase);
    }

    private get verifyEmailVerifcationPinUseCase(): IVerifyEmailVerifcationPinUseCase {
        return container.resolve<IVerifyEmailVerifcationPinUseCase>(DI.USECASES.IVerifyEmailVerifcationPinUseCase);
    }

    private get loginStep1UseCase(): ILoginStep1UseCase {
        return container.resolve<ILoginStep1UseCase>(DI.USECASES.ILoginStep1UseCase);
    }

    private get loginCredentialsUseCase(): ILoginCredentialsUseCase {
        return container.resolve<ILoginCredentialsUseCase>(DI.USECASES.ILoginCredentialsUseCase);
    }

    private get loginWithTokenUseCase(): ILoginWithTokenUseCase {
        return container.resolve<ILoginWithTokenUseCase>(DI.USECASES.ILoginWithTokenUseCase);
    }

    private get loginOtpStep1UseCase(): ILoginOtpStep1UseCase {
        return container.resolve<ILoginOtpStep1UseCase>(DI.USECASES.ILoginOtpStep1UseCase);
    }

    private get loginOtpStep2UseCase(): ILoginOtpStep2UseCase {
        return container.resolve<ILoginOtpStep2UseCase>(DI.USECASES.ILoginOtpStep2UseCase);
    }

    private get generatePinUseCase(): IGeneratePinUseCase {
        return container.resolve<IGeneratePinUseCase>(DI.USECASES.IGeneratePinUseCase);
    }

    private get verifyPinUseCase(): IVerifyPinUseCase {
        return container.resolve<IVerifyPinUseCase>(DI.USECASES.IVerifyPinUseCase);
    }

    private get resetPasswordStep1UseCase(): IResetPasswordStep1UseCase {
        return container.resolve<IResetPasswordStep1UseCase>(DI.USECASES.IResetPasswordStep1UseCase);
    }

    private get resetPaswordStep2UseCase(): IResetPaswordStep2UseCase {
        return container.resolve<IResetPaswordStep2UseCase>(DI.USECASES.IResetPaswordStep2UseCase);
    }

    private get forgotPasswordGeneratePinByEmailUseCase(): IForgotPasswordGeneratePinByEmailUseCase {
        return container.resolve<IForgotPasswordGeneratePinByEmailUseCase>(
            DI.USECASES.IForgotPasswordGeneratePinByEmailUseCase
        );
    }

    private get forgotPasswordGeneratePinByMsisdnUseCase(): IForgotPasswordGeneratePinByMsisdnUseCase {
        return container.resolve<IForgotPasswordGeneratePinByMsisdnUseCase>(
            DI.USECASES.IForgotPasswordGeneratePinByMsisdnUseCase
        );
    }

    private get forgotPasswordVerifyPinByEmailUseCase(): IForgotPasswordVerifyPinByEmailUseCase {
        return container.resolve<IForgotPasswordVerifyPinByEmailUseCase>(
            DI.USECASES.IForgotPasswordVerifyPinByEmailUseCase
        );
    }

    private get forgotPasswordVerifyPinByMsisdnUseCase(): IForgotPasswordVerifyPinByMsisdnUseCase {
        return container.resolve<IForgotPasswordVerifyPinByMsisdnUseCase>(
            DI.USECASES.IForgotPasswordVerifyPinByMsisdnUseCase
        );
    }

    private get forgotPasswordUpdatePasswordByEmailUseCase(): IForgotPasswordUpdatePasswordByEmailUseCase {
        return container.resolve<IForgotPasswordUpdatePasswordByEmailUseCase>(
            DI.USECASES.IForgotPasswordUpdatePasswordByEmailUseCase
        );
    }

    private get forgotPasswordUpdatePasswordByMsisdnUseCase(): IForgotPasswordUpdatePasswordByMsisdnByUseCase {
        return container.resolve<IForgotPasswordUpdatePasswordByMsisdnByUseCase>(
            DI.USECASES.IForgotPasswordUpdatePasswordByMsisdnByUseCase
        );
    }

    private get qrGenerateCodeUseCase(): IQrGenerateCodeUseCase {
        return container.resolve<IQrGenerateCodeUseCase>(DI.USECASES.IQrGenerateCodeUseCase);
    }

    private get qrAuthenticateCodeUseCase(): IQrAuthenticateCodeUseCase {
        return container.resolve<IQrAuthenticateCodeUseCase>(DI.USECASES.IQrAuthenticateCodeUseCase);
    }

    private get qrCodeLoginUseCase(): IQrCodeLoginUseCase {
        return container.resolve<IQrCodeLoginUseCase>(DI.USECASES.IQrCodeLoginUseCase);
    }

    private get qrCodePairingUseCase(): IQrCodePairingUseCase {
        return container.resolve<IQrCodePairingUseCase>(DI.USECASES.IQrCodePairingUseCase);
    }

    private get qrCodeLinkUseCase(): IQrCodeLinkUseCase {
        return container.resolve<IQrCodeLinkUseCase>(DI.USECASES.IQrCodeLinkUseCase);
    }

    private get internalVerifyUserUseCase(): IInternalVerifyUserUseCase {
        return container.resolve<IInternalVerifyUserUseCase>(DI.USECASES.IInternalVerifyUserUseCase);
    }

    private get sendAccountActivationUseCase(): ISendAccountActivationUseCase {
        return container.resolve<ISendAccountActivationUseCase>(DI.USECASES.ISendAccountActivationUseCase);
    }

    private get paymentSwitchGenerateUseCase(): IPaymentSwitchGenerateUseCase {
        return container.resolve<IPaymentSwitchGenerateUseCase>(DI.USECASES.IPaymentSwitchGenerateUseCase);
    }

    private get paymentSwitchVerifyUseCase(): IPaymentSwitchVerifyUseCase {
        return container.resolve<IPaymentSwitchVerifyUseCase>(DI.USECASES.IPaymentSwitchVerifyUseCase);
    }

    private get resubscribeOtpSendUseCase(): IResubscribeOtpSendUseCase {
        return container.resolve<IResubscribeOtpSendUseCase>(DI.USECASES.IResubscribeOtpSendUseCase);
    }

    private get resubscribeOtpVerifyUseCase(): IResubscribeOtpVerifyUseCase {
        return container.resolve<IResubscribeOtpVerifyUseCase>(DI.USECASES.IResubscribeOtpVerifyUseCase);
    }

    private get resubscribeCreditCardUseCase(): IResubscribeCreditCardUseCase {
        return container.resolve<IResubscribeCreditCardUseCase>(DI.USECASES.IResubscribeCreditCardUseCase);
    }

    private get getCountryConfigsUseCase(): IGetCountryConfigsUseCase {
        return container.resolve<IGetCountryConfigsUseCase>(DI.USECASES.IGetCountryConfigsUseCase);
    }

    private get unsubscribeUseCase(): IUserUnsubscribeUseCase {
        return container.resolve<IUserUnsubscribeUseCase>(DI.USECASES.IUserUnsubscribeUseCase);
    }

    private get legacyMigrateUseCase(): ILegacyMigrateUseCase {
        return container.resolve<ILegacyMigrateUseCase>(DI.USECASES.ILegacyMigrateUseCase);
    }

    private get legacyMigrateGenerateUseCase(): ILegacyMigrateGenerateUseCase {
        return container.resolve<ILegacyMigrateGenerateUseCase>(DI.USECASES.ILegacyMigrateGenerateUseCase);
    }

    private get legacyMigrateVerifyUseCase(): ILegacyMigrateVerifyUseCase {
        return container.resolve<ILegacyMigrateVerifyUseCase>(DI.USECASES.ILegacyMigrateVerifyUseCase);
    }

    private get formSignatureObject(): IFormSignatureObjectUseCase {
        return container.resolve<IFormSignatureObjectUseCase>(DI.USECASES.IFormSignatureObjectUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async locateUser(reqBody: ILocateUserReqBody): Promise<ILocateUserEntity> {
        return await this.locateUserUseCase.execute(reqBody);
    }
    async generateEmailVerifcationPin(email: string, language: string): Promise<boolean> {
        return await this.generateEmailVerifcationPinUseCase.execute(email, language);
    }
    async verifyEmailVerifcationPin(guid: string): Promise<boolean> {
        return await this.verifyEmailVerifcationPinUseCase.execute(guid);
    }
    async loginStep1(username: string, agent: string): Promise<ILoginStep1Response> {
        return await this.loginStep1UseCase.execute(username, agent);
    }

    async loginCredentials(
        username: string,
        password: string,
        agent: string,
        tokenNeeded: boolean
    ): Promise<ILoginSuccessResponse> {
        return await this.loginCredentialsUseCase.execute(username, password, agent, tokenNeeded);
    }
    async loginWithToken(
        username: string,
        agent: string,
        grantType: string,
        token: string,
        identityToken: string
    ): Promise<IApisLoginResponse> {
        return await this.loginWithTokenUseCase.execute(username, agent, grantType, token, identityToken);
    }
    async loginOtpStep1(language: string, username: string, agent: string): Promise<ILoginOtpStep1Response> {
        return await this.loginOtpStep1UseCase.execute(language, username, agent);
    }

    async loginOtpStep2(
        language: string,
        username: string,
        agent: string,
        otp: string
    ): Promise<ILoginOtpStep2Response> {
        return await this.loginOtpStep2UseCase.execute(language, username, agent, otp);
    }

    async generatePin(reqBody: IGeneratePinReqBody): Promise<IGeneratePinEntity> {
        return await this.generatePinUseCase.execute(reqBody);
    }

    async verifyPin(reqBody: IVerifyPinReqBody): Promise<IVerifyPinEntity> {
        return await this.verifyPinUseCase.execute(reqBody);
    }

    async resetPasswordStep1(lang: string, reqBody: IResetPasswordStep1ReqBody): Promise<IResetPasswordStep1Entity> {
        return await this.resetPasswordStep1UseCase.execute(lang, reqBody);
    }

    async resetPaswordStep2(lang: string, reqBody: IResetPasswordStep2ReqBody): Promise<IResetPasswordStep2Entity> {
        return await this.resetPaswordStep2UseCase.execute(lang, reqBody);
    }

    async forgotPasswordGeneratePinByEmail(email: string): Promise<IForgotPasswordGeneratePinEntity> {
        return await this.forgotPasswordGeneratePinByEmailUseCase.execute(email);
    }

    async forgotPasswordGeneratePinByMsisdn(msisdn: string): Promise<IForgotPasswordGeneratePinEntity> {
        return await this.forgotPasswordGeneratePinByMsisdnUseCase.execute(msisdn);
    }

    async forgotPasswordVerifyPinByEmail(
        otp: string,
        verificationGuid: string
    ): Promise<IForgotPasswordVerifyPinEntity> {
        return await this.forgotPasswordVerifyPinByEmailUseCase.execute(otp, verificationGuid);
    }

    async forgotPasswordVerifyPinByMsisdn(
        otp: string,
        verificationGuid: string
    ): Promise<IForgotPasswordVerifyPinEntity> {
        return await this.forgotPasswordVerifyPinByMsisdnUseCase.execute(otp, verificationGuid);
    }

    async forgotPasswordUpdatePasswordByEmail(
        reqBody: IForgotPasswordUpdateEmailReqBody
    ): Promise<IForgotPasswordVerifyPinEntity> {
        return await this.forgotPasswordUpdatePasswordByEmailUseCase.execute(reqBody);
    }

    async forgotPasswordUpdatePasswordByMsisdn(
        reqBody: IForgotPasswordUpdateEmailReqBody
    ): Promise<IForgotPasswordVerifyPinEntity> {
        return await this.forgotPasswordUpdatePasswordByMsisdnUseCase.execute(reqBody);
    }

    async qrGenerateCode(
        type: string,
        username: string | undefined,
        timestamp: number,
        payload: string | { [key: string]: any },
        language: string
    ): Promise<IQrGenerateCodeResponse['data']> {
        return await this.qrGenerateCodeUseCase.execute(type, username, timestamp, payload, language);
    }

    async qrAuthenticateCode(apiKey: string, qrCode: string, token: string, identityToken: string): Promise<boolean> {
        return await this.qrAuthenticateCodeUseCase.execute(apiKey, qrCode, token, identityToken);
    }

    async qrCodeLogin(
        qrCode: string,
        timestamp: number,
        language: string,
        payload: { [key: string]: any } | string
    ): Promise<IUserData> {
        return await this.qrCodeLoginUseCase.execute(qrCode, timestamp, language, payload);
    }

    async qrCodePairing(bucketId: string): Promise<IQrCodePairResponse> {
        return await this.qrCodePairingUseCase.execute(bucketId);
    }

    async internalVerifyUser(username: string, recaptchaToken: string): Promise<IUserDetails[]> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.internalVerifyUserUseCase.execute(username, recaptchaToken, csrfToken);
    }

    async sendAccountActivation(payload: IAccountActivationPayload): Promise<IAccountActivationResponse> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.sendAccountActivationUseCase.execute(payload, csrfToken);
    }

    async paymentSwitchGenerate(payload: IPaymentSwitchGenerateParams): Promise<any> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.paymentSwitchGenerateUseCase.execute(payload, csrfToken);
    }

    async paymentSwitchVerify(payload: IPaymentSwitchVerifyParams): Promise<any> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.paymentSwitchVerifyUseCase.execute(payload, csrfToken);
    }

    async resubscribeOtpSend(
        payload: IReSubscribeOtpSendParams,
        authToken: string,
        authSign: string,
        identityToken: string
    ): Promise<IReSubscribeOtpSendResponse['data']> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.resubscribeOtpSendUseCase.execute(payload, authToken, authSign, identityToken, csrfToken);
    }

    async resubscribeOtpVerify(
        payload: IReSubscribeOtpVerifyParams,
        authToken: string,
        authSign: string,
        identityToken: string
    ): Promise<IReSubscribeOtpVerifyResponse['data']> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.resubscribeOtpVerifyUseCase.execute(payload, authToken, authSign, identityToken, csrfToken);
    }

    async resubscribeCreditCard(
        payload: IReSubscribeCreditCardParams,
        authToken: string,
        authSign: string
    ): Promise<IReSubscribeCreditCardResponse> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.resubscribeCreditCardUseCase.execute(payload, authToken, authSign, csrfToken);
    }
    async getCountryConfigs(
        username: string,
        identityToken: string,
        apiKey: string,
        authToken: string,
        authSign: string
    ): Promise<IPaymentConfigEntity> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.getCountryConfigsUseCase.execute(
            username,
            identityToken,
            apiKey,
            authToken,
            authSign,
            csrfToken
        );
    }

    async unsubscribe(
        username: string,
        authToken: string,
        authSign: string,
        reqBody: IUnsubscribeReqBody
    ): Promise<IUnsubscribeEntity> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.unsubscribeUseCase.execute(username, authToken, authSign, csrfToken, reqBody);
    }

    async legacyMigrate(
        payload: ILegacyMigrateRequest,
        authToken: string,
        authSign: string
    ): Promise<ILegacyMigrateResponse> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.legacyMigrateUseCase.execute(payload, authToken, authSign, csrfToken);
    }

    async legacyMigrateGenerate(
        payload: ILegacyMigrateRequest,
        authToken: string,
        authSign: string
    ): Promise<ILegacyMigrateResponse> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.legacyMigrateGenerateUseCase.execute(payload, authToken, authSign, csrfToken);
    }
    async legacyMigrateVerify(
        payload: ILegacyMigrateRequest,
        authToken: string,
        authSign: string
    ): Promise<ILegacyMigrateResponse> {
        const csrfToken = await this.formSignatureObject.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.legacyMigrateVerifyUseCase.execute(payload, authToken, authSign, csrfToken);
    }
}
